export enum NumberFormatMode {
    decimalTwo = 0,
    roundUp = 1,
    roundDown = 2,
    round = 3,
    decimalZero = 4,
    decimalOne = 5
}
